import React, { useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import SelectCommon from "../../../components/selects/select.common";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Cession de droits sociaux
// Id simulateur 83

function Simulateur_83(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [nature_droits, setNatureDroits] = useState(0);
  const [nature_biens, setNatureBiens] = useState(0);
  const [nombre_parts_capital, setPartsCapital] = useState(0);
  const [nombre_parts_cedees, setPartsCedees] = useState(0);
  const [prix_cession, setPrixCession] = useState(0);
  const [montant_frais, setMontantFrais] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          nature_droits: parseInt(nature_droits),
          nature_biens: parseInt(nature_biens),
          nombre_parts_capital: parseInt(nombre_parts_capital),
          nombre_parts_cedees: parseFloat(nombre_parts_cedees),
          prix_cession: parseFloat(prix_cession),
          montant_frais: parseFloat(montant_frais),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setNatureDroits) {
        Object.assign(object["inputs"], { nature_droits: parseInt(value) });
      }

      if (setter === setNatureBiens) {
        Object.assign(object["inputs"], { nature_biens: parseInt(value) });
      }

      if (setter === setPartsCapital) {
        Object.assign(object["inputs"], { nombre_parts_capital: parseInt(value) });
      }

      if (setter === setPartsCedees) {
        Object.assign(object["inputs"], { nombre_parts_cedees: parseFloat(value) });
      }

      if (setter === setPrixCession) {
        Object.assign(object["inputs"], { prix_cession: parseFloat(value) });
      }

      if (setter === setMontantFrais) {
        Object.assign(object["inputs"], { montant_frais: parseFloat(value) });
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
        
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  const natureDroits = [
    {
      id: 0,
      name: "Parts sociales de société à prépondérance immobilière",
    },
    {
      id: 1,
      name: "Parts sociales représentatives d’APPORT EN NATURE (sauf société à prépondérance immobilière)",
    },
    {
      id: 2,
      name: "Parts sociales autres cas (Sociétés dont le capital n’est pas divisé en action - sauf société à prépondérance immobilière-)",
    },
    {
      id: 3,
      name: "Actions cotées en bourse, cession constatée par acte",
    },
    {
      id: 4,
      name: "Actions cotées en bourse, cession non constatée par acte",
    },
    {
      id: 5,
      name: "Actions non cotées en bourse, cession constatée ou non par acte",
    },
    {
      id: 6,
      name: "Obligations",
    },
  ];

  const natureBiens = [
    {
      id: 0,
      name: "Biens immobiliers",
    },
    {
      id: 1,
      name: "Fonds de commerce",
    },
    {
      id: 2,
      name: "Actions",
    },
  ];

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Acte non tarifé donnant lieu à des honoraires dans les conditions de perception visées par l’article L. 444-2
          alinéa 3 du Code de commerce.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quelle est la nature des droits sociaux cédés ?
            <ToolTipPerso title={"La nature détermine la fiscalité à appliquer"} />
          </div>
          <SelectCommon
            items={natureDroits}
            defaultValue={0}
            nameField={"name"}
            optionValue={"id"}
            handleChange={handleChange}
            setter={setNatureDroits}
          />
        </div>

        {nature_droits == 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Quel est la nature des biens apportés en nature représentant les titres cédés ?
            </div>
            <SelectCommon
              items={natureBiens}
              defaultValue={0}
              nameField={"name"}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setNatureBiens}
            />
          </div>
        ) : (
          <></>
        )}

        {nature_droits == 2 ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Quel est le nombre total de parts composant le capital social ?
              </div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le nombre"}
                setter={setPartsCapital}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Quel est le nombre de parts cédées ?</div>
              <TextfieldNumber
                handleChange={handleChange}
                type={"number"}
                placeholder={"Indiquer le nombre"}
                setter={setPartsCedees}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le prix de cession ?
            <ToolTipPerso
              title={"Sur le prix exprimé dans l’acte augmenté des charges ou la déclaration estimative des parties"}
            />
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le prix"}
            setter={setPrixCession}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le montant estimé des frais à refacturer au client ?
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantFrais}
          />
        </div>

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_83;
